<template>
  <div class="recommendFive">
    <recommend-title :titleObj="titleObj"></recommend-title>
    <div class="swiper-inner">
      <swiper :options="swiperOption">
        <swiper-slide v-for="(item,index) in list" :key="index">
          <el-card shadow="hover" :body-style="{ padding: '0px' }" class="card">
            <img :src="item.imgUrl" class="image">
            <div style="padding: 14px;text-align: center;">
              <span>好吃的汉堡</span>
            </div>
          </el-card>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
  </div>
</template>
<script>
import RecommendTitle from './recommendTitle'
import ListPanel from './listPanel'
export default {
  name: '',
  components: {
    'recommend-title': RecommendTitle,
    'list-panel': ListPanel
  },
  data () {
    return {
      swiperOption: {
        effect: 'slide',
        grabCursor: true,
        // centeredSlides: true,
        // slidesPerView: 'auto',
        slidesPerView: 4,
        // coverflowEffect: {
        //   rotate: 50,
        //   stretch: 0,
        //   depth: 100,
        //   modifier: 1
        // },
        // pagination: {
        //   el: '.swiper-pagination'
        // },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      titleObj: {
        color: '#7B63A0',
        text: '党政影响',
        link: '/home/classification'
      },
      list: [{
        imgUrl: require('@/assets/images/aa.jpg'),
        name: 'w我们从此是路人',
        author: '老王',
        oldMoney: '100.00',
        nowMoney: '50.22',
        score: 5
      }, {
        imgUrl: require('@/assets/images/aa.jpg'),
        name: '哈哈哈',
        author: '老王',
        oldMoney: '100.00',
        nowMoney: '50.22',
        score: 2.5
      }, {
        imgUrl: require('@/assets/images/aa.jpg'),
        name: '哈哈哈',
        author: '老王',
        oldMoney: '100.00',
        nowMoney: '50.22',
        score: 5
      }, {
        imgUrl: require('@/assets/images/aa.jpg'),
        name: '哈哈哈',
        author: '老王',
        oldMoney: '100.00',
        nowMoney: '50.22',
        score: 0
      }, {
        imgUrl: require('@/assets/images/aa.jpg'),
        name: '哈哈哈',
        author: '老王',
        oldMoney: '100.00',
        nowMoney: '50.22'
      }]
    }
  }
}
</script>
<style lang="less" scoped>
  .swiper-inner {
    width: 100%;
    padding-top: 50px;
    padding-bottom: 50px;
  }
  .swiper-slide {
    background-position: center;
    background-size: cover;
    width: 300px;
  }
  .recommendFive{
    margin-top: 30px;
    padding: 0 10px;
    .card{
      img{
        width: 100%;
        height: 200px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/recommendFive.vue


// WEBPACK FOOTER //
// src/components/Home/recommendFive.vue